import { LazyImage } from "@website/ui/lazy-image";
import { getChannel } from "@website/utils/channel/get-channel";
import { isChannel } from "@website/utils/channel/helpers";
import { isSSR } from "@website/utils/is-ssr";
import { replaceHostToCurrent } from "@website/utils/url-formatter";
import { BannerMediumItemPropertiesType } from "@website/widget/banner-medium/banner-medium.types";
import styles from "@website/widget/banner-medium/components/banner-medium-item/banner-medium-item.module.scss";
import { useRouter } from "next/router";
import { FC, memo, useEffect, useState } from "react";

const BannerMediumItem: FC<BannerMediumItemPropertiesType> = (properties) => {
  const {
    id = 0,
    alt,
    desktopSrc,
    mobileSrc,
    linkTo,
    isSameTab,
    height,
    width,
    shouldRedirectUsingJs
  } = properties;
  const { pathname } = useRouter();
  const channel = getChannel();
  const router = useRouter();

  const [ID, setID] = useState("");

  useEffect(() => {
    try {
      setID(
        `${
          pathname?.length === 1 ? "hotel" : pathname?.slice(1)
        }_${channel}_medium-banner_${id + 1}`
      );
    } catch {
      setID("medium-banner");
    }
  }, [channel, id, pathname]);

  const Image = (
    <LazyImage
      alt={alt}
      className={styles["image"]}
      height={height}
      id={ID}
      loading="lazy"
      pictures={[
        {
          media: "min-width: 1024px",
          srcSet: desktopSrc
        }
      ]}
      src={mobileSrc as string}
      width={width}
    />
  );

  if (linkTo) {
    const pathName = router.pathname;
    const routerQuery = router?.query;
    const snappTripToken = isSSR()
      ? ""
      : localStorage.getItem("snappTripToken");
    if (pathName === "/flights" && snappTripToken) {
      routerQuery.authToken = snappTripToken;
    }
    const jekLink = `${
      linkTo.includes("?")
        ? `${linkTo}&${new URLSearchParams(routerQuery as any)}`
        : `${linkTo}?${new URLSearchParams(routerQuery as any)}`
    }`;

    const target = isSameTab ? "_self" : "_blank";
    const link = isChannel(["jek"]) ? jekLink : linkTo;
    const handleBannerClick = () =>
      (window.location.href = `${replaceHostToCurrent(link)}`);
    return shouldRedirectUsingJs ? (
      <div
        onClick={handleBannerClick}
        className={`${styles["image-wrapper"]} cursor-pointer`}
      >
        {Image}
      </div>
    ) : (
      <a
        className={styles["image-wrapper"]}
        href={link}
        rel="noreferrer"
        target={target}
      >
        {Image}
      </a>
    );
  }
  return <div className={styles["image-wrapper"]}>{Image}</div>;
};

const BannerMediumItemMemoized = memo(BannerMediumItem);
export { BannerMediumItemMemoized as BannerMediumItem };
